import styled from "styled-components";
import { SubTextBold } from "src/apps/components/typography/Texts";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { colors } from "@permisso/permisso-components";

interface BadgeProps {
  backgroundColor?: string;
  text: string;
  textColor: string;
  iconColor?: string;
  rightIconSVG?: React.ReactNode;
  leftIconSVG?: React.ReactNode;
}

export const Badge = ({
  backgroundColor = colors.grey800,
  text,
  textColor,
  iconColor = colors.grey0,
  rightIconSVG = null,
  leftIconSVG = null,
}: BadgeProps) => {
  const { t } = useTranslations();
  return (
    <Container $backgroundColor={backgroundColor}>
      {leftIconSVG && (
        <IconContainer>
          <Icon color={iconColor} size={ICON_SIZES.s14} path={leftIconSVG} />
        </IconContainer>
      )}
      <SubTextBold $color={textColor}>{t(text)}</SubTextBold>
      {rightIconSVG && (
        <IconContainer>
          <Icon color={iconColor} size={ICON_SIZES.s14} path={rightIconSVG} />
        </IconContainer>
      )}
    </Container>
  );
};

const Container = styled.div<{ $backgroundColor: string }>`
  display: flex;
  flex-direction: row;
  padding: 0.063rem 0.5rem 0.063rem 0.5rem;
  border-radius: 0.625rem;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  align-items: center;
  gap: 0.25rem;
`;

const IconContainer = styled.div`
  display: flex;
  width: 0.75rem;
  height: 0.75rem;
  align-items: center;
  justify-content: center;
`;
